import React from 'react';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { EditAlt } from 'styled-icons/boxicons-regular';
import Logo from '../../../system/access/images/icon.png';
import ModalEditEmail from './modalEditEmail';

const MainContainer = styled.main`
  width: 95%;
  height: 80vh;
  padding: 10px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  article {
    width: calc(100% - 20px);
    padding: 10px;
    h1 {
      font-size: 18px;
      color: ${palette.grayNew};
      margin-bottom: 8px;
    }
  }
  .editMain {
    width: calc(100% - 18px);
    margin-top: 35px;
    background-color: ${palette.white};
    padding: 10px;
    border-radius: 10px;
    box-shadow: ${palette.lightBS};
    position: relative;
    display: grid;
    grid-gap: 20px;
    grid-template-rows: 70% 30%;
    .icon {
      position: absolute;
      width: 20px;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
    img {
      width: 100px;
      height: 100px;
      margin: auto;
    }
    .boxEmailEdit {
      display: grid;
      grid-template-rows: 20% 80%;
      h2 {
        font-size: 18px;
        color: ${palette.grayNew};
        margin: 10px auto;
      }
      div {
        font-size: 14px;
        color: ${palette.grayNew};
      }
    }
  }
  .boxMail {
    width: 80%;
    background-color: ${palette.white};
    border-radius: 10px;
    padding: 10px;
    height: 100px;
    box-shadow: ${palette.lightBS};
    margin-bottom: 30px;
    cursor: pointer;
    border: none;
    transition-duration: 1s;
    h2 {
      font-size: 18px;
      color: ${palette.grayNew};
      padding-top: 5px;
      padding-bottom: 5px;
      transition-duration: 1s;
    }
    div {
      margin-top: 10px;
      height: calc(100% - 40px);
      overflow: hidden;
      font-size: 14px;
      font-family: ${palette.nereg};
      color: ${palette.grayNew};
      text-overflow: ellipsis;
    }
  }
  #active {
    transition-duration: 1s;
    border: 1px solid ${palette.blue};
    h2 {
      transition-duration: 1s;
      color: ${palette.blue};
    }
  }
  .ql-align-center {
    text-align: center !important;
  }

  .ql-align-justify {
    text-align: justify !important;
  }

  .ql-align-right {
    text-align: right !important;
  }
`;

const ContainerEmail = () => {
  const [selectEmail, setSelectEmail] = React.useState(0);
  const [selectEmailData, setSelectEmailData] = React.useState({});
  const [statusModal, setStatusModal] = React.useState(false);
  const { t } = useTranslation(['admin']);
  const { EmailTemplate, companyLogo } = useSelector((state) => state.company);

  const onSelectEmail = (num) => {
    const dataEmail = EmailTemplate[num];
    setSelectEmailData(dataEmail);
    setSelectEmail(num);
  };

  React.useEffect(() => {
    setSelectEmailData(EmailTemplate[selectEmail]);
  }, [EmailTemplate]);

  const toogleModal = () => setStatusModal(!statusModal);
  return (
    <MainContainer>
      {statusModal ? <ModalEditEmail toogleModal={toogleModal} selectEmailData={selectEmailData} /> : null}
      <article>
        <h1>{t('titleTemplateMail')}</h1>
        {EmailTemplate?.map((emialTem, idx) => (
          <div className="boxMail" id={idx === selectEmail ? 'active' : ''} onClick={() => onSelectEmail(idx)}>
            <h2>{t(emialTem.objectID)}</h2>
            <div dangerouslySetInnerHTML={{ __html: t(`${emialTem.objectID}Body`) }} />
          </div>
        ))}
      </article>
      <article className="editMain">
        <EditAlt className="icon" onClick={toogleModal} />
        <div className="boxEmailEdit">
          <h2> {t(selectEmailData?.objectID)} </h2>
          <div dangerouslySetInnerHTML={{ __html: selectEmailData?.body }} />
        </div>
        <img alt="logo" src={companyLogo || Logo} />
      </article>
    </MainContainer>
  );
};

export default ContainerEmail;
